import React, { AriaRole } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IconUploadSdOutline } from '@saucelabs/ds-icons';
import { actions as modalActions } from '@saucelabs/sl-container-modal';

import { MANUAL_TEST_EVENTS, trackEvent } from '../../../tracking';
import {
  constants as uploadFileToSdCardConstants,
  UploadToSdCardModal,
} from '../../uploadToSdCard';
import selectors from '../selectors';
import GenericButton from './GenericButton';

const UploadFileToSdCardButton: React.FC<{ role?: AriaRole }> = ({ role }) => {
  const dispatch = useDispatch<ReduxDispatcher>();
  const {
    deviceDescriptor,
    deviceToolsDisabled,
  } = useSelector(selectors.toolbarButtonSelector);

  const showUploadFileModal = () => {
    void dispatch(modalActions.showModal(uploadFileToSdCardConstants.MODAL_KEY));

    trackEvent(MANUAL_TEST_EVENTS.SHOW_UPLOAD_FILES_TO_SD_CARD, {
      deviceName: deviceDescriptor.name,
    });
  };

  return (
    <>
      <UploadToSdCardModal />

      <GenericButton
        dataQa="live-session-toolbar-upload-to-sd-card-button"
        disabled={deviceToolsDisabled}
        icon={IconUploadSdOutline}
        label="Upload File to SD Card"
        onPress={showUploadFileModal}
        role={role}
      />
    </>
  );
};

UploadFileToSdCardButton.displayName = 'UploadFileToSdCardButton';

export default UploadFileToSdCardButton;
